import { Component, EventEmitter, Output, Input, booleanAttribute } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

@Component({
	selector: 'ui-porto-bank-confirm-slider',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './confirm-slider.component.html',
	styleUrls: ['./confirm-slider.component.scss'],
})
export class ConfirmSliderUiComponent {
	@Input({ transform: booleanAttribute }) line = false
	@Input() isCheckedTerms = false
	@Output() checkValueChange = new EventEmitter<boolean>()

	checkTermsChange(event: Event) {
		const target = event.target as HTMLInputElement
		this.checkValueChange.emit(target.checked)
	}
}
